const getTimeIntervalString = (interval) => {
  const minute = 1000 * 60;
  const hour = minute * 60;
  const day = hour * 24;

  if (interval < hour) {
    const minutes = Math.round(interval / minute);
    return `Every ${minutes} Minute${minutes > 1 ? 's' : ''}`;
  } else if (interval < day) {
    const hours = Math.round(interval / hour);
    return `Every ${hours} Hour${hours > 1 ? 's' : ''}`;
  } else {
    const days = Math.round(interval / day);
    return `Every ${days} Day${days > 1 ? 's' : ''}`;
  }
};

export default getTimeIntervalString;
